import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { AchievementBadge } from './achievement-badge'
import { AchievementCondition } from './achievement-condition'

export const AchievementConditionGroup = pgTable(
  'achievement_condition_group',
  {
    id: uuid().notNull().primaryKey().defaultRandom(),
    achievementBadgeId: uuid()
      .notNull()
      .references(() => AchievementBadge.id, { onDelete: 'cascade' }),
    operator: text({ enum: ['AND', 'OR'] })
      .notNull()
      .default('AND'),
    order: integer().notNull().default(0),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }),
  },
  (table) => [
    index('achievement_condition_group_achievement_badge_id_idx').on(table.achievementBadgeId),
    index('achievement_condition_group_order_idx').on(table.order),
    index('achievement_condition_group_created_at_idx').on(table.createdAt),
    index('achievement_condition_group_updated_at_idx').on(table.updatedAt),
  ],
)

export const achievementConditionGroupRelations = relations(AchievementConditionGroup, ({ one, many }) => ({
  achievementBadge: one(AchievementBadge, {
    fields: [AchievementConditionGroup.achievementBadgeId],
    references: [AchievementBadge.id],
  }),
  conditions: many(AchievementCondition),
}))

export const InsertAchievementConditionGroupSchema = createInsertSchema(AchievementConditionGroup).omit({ id: true })
export const UpdateAchievementConditionGroupSchema = createUpdateSchema(AchievementConditionGroup)
  .omit({ id: true })
  .partial()
export const SelectAchievementConditionGroupSchema = createSelectSchema(AchievementConditionGroup)

export type InsertAchievementConditionGroup = typeof AchievementConditionGroup.$inferInsert
export type UpdateAchievementConditionGroup = z.infer<typeof UpdateAchievementConditionGroupSchema>
export type SelectAchievementConditionGroup = typeof AchievementConditionGroup.$inferSelect
